import { Tables } from '@/types/database.types';
import { CustomQueryOptions } from '@/types/query';
import { useQuery, queryOptions } from '@tanstack/react-query';
import {
  getBalanceActionHistory,
  getCredit,
  getCreditBalanceSummary,
  getInvoice,
  getUserBalance,
  getUserCurrentBalance,
} from '.';
import {
  GetBalanceActionHistoryParams,
  GetCreditRequest,
  GetCreditResponse,
  getCurrentBalnce,
  GetInvoiceResponse,
} from './type';
import { PaginationResponse } from '@/types';

const keyname = 'payment';

export const useGetUserBalance = (
  option?: CustomQueryOptions<Tables<'user_balance'>>
) => {
  return useQuery({
    queryKey: [`${keyname}-balance`],
    queryFn: getUserBalance,
    ...option,
  });
};

export const useGetUserCurrentBalance = (
  option?: CustomQueryOptions<getCurrentBalnce>
) => {
  return useQuery({
    queryKey: [`${keyname}-current-balance`],
    queryFn: getUserCurrentBalance,
    ...option,
  });
};

export const useGetgetBalanceActionHistory = (
  params: GetBalanceActionHistoryParams,
  option?: CustomQueryOptions<PaginationResponse<Tables<'balance_history'>>>
) => {
  return useQuery({
    queryKey: [[`${keyname}-balance-action`], { params }],
    queryFn: async () => getBalanceActionHistory(params),
    ...option,
  });
};

export const useGetInvoice = (
  option?: CustomQueryOptions<GetInvoiceResponse>
) => {
  return useQuery({
    queryKey: [`${keyname}-invoice`],
    queryFn: async () => getInvoice(),
    ...option,
  });
};

export const useGetCredit = (
  params: GetCreditRequest,
  option?: CustomQueryOptions<GetCreditResponse>
) => {
  return useQuery({
    queryKey: [`${keyname}-credit`, { params }],
    queryFn: async () => getCredit(params),
    ...option,
  });
};

// export const getSummaryCreditOption = () => {
//   return queryOptions({
//     queryKey: [`${keyname}-summary-credit`],
//     queryFn: async () => {
//       const { data: credit } = await getCredit({
//         limit: 10,
//       });
//       if (!credit) return 0;

//       const currentTime = dayjs().unix(); // Current time in Unix timestamp

//       return credit
//         .filter((item) => {
//           // Filter out voided credits
//           if (item.voided_at) return false;

//           // Filter out expired credits
//           if (item.expires_at && item.expires_at < currentTime) return false;

//           // Filter out credits that are not yet effective
//           if (item.effective_at && item.effective_at > currentTime)
//             return false;

//           return true;
//         })
//         .reduce((total, item) => {
//           // Convert from cents to dollars (following the pattern in credit/index.tsx)
//           return total + item.amount.monetary.value / 100;
//         }, 0);
//     },
//     staleTime: 1000 * 60 * 5,
//   });
// };

export const useGetCreditBalanceSummaryOption = () => {
  return queryOptions({
    queryKey: [`${keyname}-credit-balance-summary`],
    queryFn: async () => getCreditBalanceSummary(),
  });
};
